import { CardApiFactory } from '@mynt/backoffice-api-spec/cards'
import Axios from 'api/axios'
import config from 'config'
import type { CardGroup } from './api'
import { mapCardGroupResponseToCardGroupData, mapCardGroupToCardGroupDto } from './mappers'

const cardApi = CardApiFactory(undefined, config.boBaseUrl, Axios)

export const getCardGroup = (customerId: string) =>
  cardApi.getCardGroup(customerId).then(({ data }) => mapCardGroupResponseToCardGroupData(data))

export const deleteCardGroupOverride = (customerId: string) => cardApi.deleteCardGroupOverride(customerId)

export const setCardGroupOverride = (customerId: string, group: CardGroup) =>
  cardApi.setCardGroupOverride(customerId, { cardGroup: mapCardGroupToCardGroupDto(group) })
